// extracted by mini-css-extract-plugin
export default {"vm":"EventGroup_vm__Bczl8"};